import { AnimatePresence, motion } from 'framer-motion'
import './addcard.scss'
import { X } from 'lucide-react'
import { useRef } from 'react';
import { CardInput } from '../../interface/interfaces';
import LoaderBtn from '../LoaderBtn/LoaderBtn';

type Prop = {
    data: CardInput,
    setData: React.Dispatch<React.SetStateAction<CardInput>>;
    toggle: boolean,
    setToggle: React.Dispatch<React.SetStateAction<boolean>>;
    saveFunc: () => void;
    discardFunc:()=> void;
    isSaving: boolean;
}


const AddCard = ({ data, isSaving, toggle, setToggle, saveFunc, setData , discardFunc }: Prop) => {

    const cardInputBox = useRef<HTMLDivElement>(null)

    // useEffect(() => {
    //     const handleClickOutside = (event: MouseEvent) => {
    //         if (
    //             toggle &&
    //             cardInputBox.current &&
    //             !cardInputBox.current.contains(event.target as Node)) {

    //             setToggle(false)
    //         }

    //     }


    //     document.addEventListener("mousedown", handleClickOutside);
    //     return () => {
    //         document.removeEventListener("mousedown", handleClickOutside);
    //     };
    //     // eslint-disable-next-line
    // }, [toggle]);

    const handleDiscard = () => {
        setToggle(false)
    }

     const formatCardNumber = (value: string) => {
    // Remove all non-digit characters
    const digits = value.replace(/\D/g, "");
    // Add a space every 4 digits
    return digits.replace(/(.{4})/g, "$1 ").trim();
  };

  const formatExpiry=(value: string) => {
  // Remove all non-digits
  let digits = value.replace(/\D/g, "");

  // Limit to 4 digits (MMYY)
  if (digits.length > 4) {
    digits = digits.slice(0, 4);
  }

  // Insert "/" after MM
  if (digits.length > 2) {
    return digits.slice(0, 2) + "/" + digits.slice(2);
  }

  return digits;
}


const formatCvv=(value:string)=>{
    let digits = value.replace(/\D/g, "");
    return digits 
}





        const handleInput = (value: string, name: string) => {
        

       const formatFunc=(value: string, name: string)=>{
         let ret_value
        switch (name) {
            case 'card_number':
                ret_value=formatCardNumber(value)
            break;


             case 'expiry_date':
                ret_value=formatExpiry(value)
            break;


             case 'cvv':
               ret_value=formatCvv(value)
            break;

            default:
                ret_value=value
            break;
        }


        return ret_value

       }
          
        setData((prev) => {
            return {
                ...prev,
                [name]: formatFunc(value,name)
            }
        })

    }


    return (
        <AnimatePresence>
            {toggle && (
                <motion.div className='addcard'
                initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}>
                    <motion.div className="cardinputbox"
                        initial={{ opacity: 0, }}
                        animate={{ opacity: 1, }}
                        exit={{ opacity: 0, }}
                        transition={{
                            type: "tween",
                            duration: 0.2,
                            ease: "easeOut",
                        }}

                        ref={cardInputBox}
                    >

                        <div>

                            <button className="close-button" onClick={() => setToggle((prev) => !prev)} >
                                <X size={20}></X>
                            </button>

                            <div className="infopack">
                                {data.id === '' && (<div className="title">Add new card</div>)}
                                {data.id !== '' && (<div className="title">Edit card</div>)}
                                <div className="text">Kindly provide accurate information.</div>
                            </div>


                            <div className="inputTab">

                                <div className="inputGrid">

                                    <div className="inputBox">
                                        <div className="label">First Name</div>
                                        <input className="input" value={data.firstname} onChange={(e)=>handleInput(e.currentTarget.value,'firstname')}></input>
                                    </div>


                                    <div className="inputBox">
                                        <div className="label">Last Name</div>
                                        <input className="input" value={data.lastname} onChange={(e)=>handleInput(e.currentTarget.value,'lastname')}></input>
                                    </div>

                                </div>


                                <div className="inputBox">
                                    <div className="label">Card Number</div>
                                    <input className="input cardinput"  value={data.card_number} onChange={(e)=>handleInput(e.currentTarget.value,'card_number')} ></input>
                                </div>

                                <div className="inputGrid">

                                    <div className="inputBox">
                                        <div className="label">Expiry Date</div>
                                        <input className="input" value={data.expiry_date} onChange={(e)=>handleInput(e.currentTarget.value,'expiry_date')}></input>
                                    </div>

                                    <div className="inputBox">
                                        <div className="label">CVV</div>
                                        <input className="input" value={data.cvv} onChange={(e)=>handleInput(e.currentTarget.value,'cvv')}></input>
                                    </div>

                                </div>


                                <hr className="line"></hr>


                                <div className="bopack">

                                     <LoaderBtn className={"btn"} text={"Save Changes"} clickFunction={saveFunc} isLoading={isSaving}></LoaderBtn>
                                
                                    <div className="crt_acc" onClick={handleDiscard}>Cancel & Discard Changes</div>
                                </div>

                            </div>

                        </div>

                    </motion.div>
                    </motion.div>)}

        </AnimatePresence>)
}

export default AddCard